import React, {Component} from "react";
import { Layout, List, Modal, Radio, Table} from "antd";
// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import Header from "../../components/header";
import LeftStu from "../../components/leftStu";
import './study.less'
import {reqCurrent, reqMyList, reqMyRank} from "../../api";
import * as moment from "moment";

const {Content} = Layout;

export class Study extends Component {

    state = {
        formalScoreRank: {},
        mockScoreRank: {},
        formalAvgScoreRank: {},
        mockAvgScoreRank: {},
        formalRightRate: 0,
        mockRightRate: {},
        list: [],
        visible: false,
        ModalText: '',
        currentUser: {},
        type: 'MOCK',
        orderList:[]
    };

    getChart = (list) => {
        // 基于准备好的dom，初始化echarts实例
        let name = [];
        let score = [];
        let arr = list.reverse();
        for (let i = 0; i < list.length; i++) {
            name.push(i+1);
            score.push(arr[i].score);
        }
        let myChart = echarts.init(document.getElementById('main'));
        let option = {
            grid: {
                show: true,
                borderColor: "transparent",
                backgroundColor: '#F4F4F4',
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: [
                {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    type: 'category',
                    name: '考试',
                    data: name,
                    axisLabel:{
                        textStyle:{
                            fontSize:18
                        }
                    },
                    nameTextStyle:{
                        fontSize:18,
                        color:'#12c4ed',
                        padding: [0, 0, 50, 0]
                    }
                }
            ],
            yAxis: [
                {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['white'],
                            width: 2,
                            type: 'solid'
                        }
                    },
                    axisLabel: {
                        textStyle:{
                            color: '#12c4ed',
                            fontSize:18
                        }
                    },   // x轴字体颜色
                    type: 'value',
                    name: '分数',
                    nameTextStyle:{
                        color: '#12c4ed',
                        fontSize:18,
                        padding: [0, 0, 20, 0]
                    }
                }
            ],
            series: [
                {
                    data: score,
                    type: 'bar',
                    barWidth: 24,
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#12c4ed'
                        }, {
                            offset: 1,
                            color: '#2f89ff'
                        }]),   //柱状颜色和圆角
                        barBorderRadius: [5, 5, 0, 0], // （顺时针左上，右上，右下，左下）
                        normal: {
                            borderColor: '#B3E6F9',//拐点边框颜色
                            borderWidth: 3,//拐点边框大小
                            barBorderRadius: [5, 5, 0, 0],
                        }
                    }
                },
                {
                    data: score,
                    type: 'line',
                    symbol: 'circle',//拐点样式
                    symbolSize: 16,//拐点大小
                    itemStyle: {
                        normal: {
                            color: '#FC896C',//拐点颜色
                            borderColor: '#F5BDB2',//拐点边框颜色
                            borderWidth: 4,//拐点边框大小
                            lineStyle: {
                                width: 3,//折线宽度
                            },
                            label: {
                                show: true,
                                formatter: '{c}分',
                                color: '#12c4ed',
                                fontSize:18
                            }
                        }
                    },
                }
            ],
            color: ['#12c4ed', '#FC896C']
        };
        // 绘制图表
        myChart.setOption(option);
    };

    getMyRank = async (type) => {
        const result = await reqMyRank(type);
        let formalRightRate = result.formalRightRate?result.formalRightRate.toString():0;
        let mockRightRate = result.mockRightRate?result.mockRightRate.toString():0;
        if(formalRightRate!==0&&formalRightRate.indexOf(".")!==-1){
            let temp = formalRightRate.split(".")[1];
            if(temp.length>1){
                let num = formalRightRate.split(".")[0]-0;
                let dot = temp.charAt(1)-0;
                if(temp.charAt(1)>4){
                    dot = temp.charAt(0)-0+1;
                }
                formalRightRate = num+dot/10;
            }
        }
        if(mockRightRate!==0&&mockRightRate.indexOf(".")!==-1){
            let temp = mockRightRate.split(".")[1];
            if(temp.length>1){
                let num = mockRightRate.split(".")[0]-0;
                let dot = temp.charAt(1)-0;
                if(temp.charAt(1)>4){
                    dot = temp.charAt(0)-0+1;
                }
                mockRightRate = num+dot/10;
            }
        }
        this.setState({
            formalScoreRank: result.formalScoreRank?result.formalScoreRank : {"rank": 0, "total": 0} ,
            mockScoreRank: result.mockScoreRank?result.mockScoreRank : {"rank": 0, "total": 0} ,
            formalAvgScoreRank: result.formalAvgScoreRank?result.formalAvgScoreRank : {"rank": 0, "total": 0} ,
            mockAvgScoreRank: result.mockAvgScoreRank?result.mockAvgScoreRank : {"rank": 0, "total": 0} ,
            formalRightRate: formalRightRate,
            mockRightRate: mockRightRate
        })
    };

    getMyList = async (type, size) => {
        const result = await reqMyList(type, size);
        const results = await reqMyList(type, size);
        this.setState({
            list: result.sort(),
            orderList:results
        });
        this.getChart(result.sort());
    };
    onGrade = async(e) => {
        this.getMyRank(e.target.value);
    };
    onChange = async (e) => {
        this.getMyList(e.target.value, 15);
        this.setState({
            type:e.target.value
        })
    };
    showReport = () => {
        this.setState({
            visible: true,
            ModalText: '成绩单'
        })
    };
    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };
    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            currentUser: result.data
        });
    };
    componentDidMount = async () => {
        this.getMyRank("CLASSROOM");
        this.getMyList("MOCK", 15);
        this.getCurrentUser();
        sessionStorage.clear();
     };

    render() {

        const {orderList,formalScoreRank, mockScoreRank, type, ModalText, visible, currentUser, formalAvgScoreRank, mockAvgScoreRank, formalRightRate, mockRightRate, list} = this.state;
        const columns = [
            {
                title: '考试场次',
                dataIndex: 'name',
                key: 'name',
                className:'name',
                render: (text, record,index) => (
                    <span>
                    {record.name}
                    </span>
                )
            },
            {
                title: '考试日期',
                dataIndex: 'beginTime',
                key: 'beginTime',
                className:'beginTime',
                render:(text,record)=>{
                        return moment(record.beginTime).format("YYYY-MM-DD HH:mm:ss")
                }
            },
            {
                title: '成绩',
                dataIndex: 'score',
                key: 'score',
                className:'score',
            }
        ];
        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftStu>LeftStu</LeftStu>
                    <Content>
                        <div className='study_box'>
                            <div className='radio_top'>
                                <Radio.Group onChange={this.onGrade} defaultValue={'CLASSROOM'}>
                                    <Radio value={'CLASSROOM'}>班级排名</Radio>
                                    <Radio value={'GRADE'}>年级排名</Radio>
                                </Radio.Group>
                            </div>
                            <div className='study_top'>
                                <div className='study_img'>
                                    <div className='img_font'>
                                        <div className='img_width width1'/>
                                        <div className='img_width width2 blue_one'>{formalScoreRank.rank}<span>/{formalScoreRank.total}</span></div>
                                        <div className='img_width width3 blue_two'>{mockScoreRank.rank}<span>/{mockScoreRank.total}</span></div>
                                    </div>
                                </div>
                                <div className='study_img img2'>
                                    <div className='img_font'>
                                        <div className='img_width width1'/>
                                        <div className='img_width width2 orange_one'>{formalAvgScoreRank.rank}<span>/{formalAvgScoreRank.total}</span></div>
                                        <div className='img_width width3 orange_two'>{mockAvgScoreRank.rank}<span>/{mockAvgScoreRank.total}</span></div>
                                    </div>
                                </div>
                                <div className='study_img img3'>
                                    <div className='img_font'>
                                        <div className='img_width width4'/>
                                        <div className='img_width width5 purple_one'>{formalRightRate}<span>%</span></div>
                                        <div className='img_width width6 purple_two'>{mockRightRate * 1}<span>%</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className='study_title'>
                                <div className='title_name'>成绩变化分析图</div>
                                <div className='title_span'>显示最近<span>15</span>次成绩</div>
                                <div className='title_radio'>
                                    <Radio.Group onChange={this.onChange} defaultValue={'MOCK'}>
                                        <Radio value={'MOCK'}>模拟试卷</Radio>
                                        <Radio value={'FORMAL'}>正式试卷</Radio>
                                    </Radio.Group>
                                    <button className='title_btn' onClick={this.showReport}>查看成绩单</button>
                                </div>
                            </div>
                            <div className='chart' id="main" style={{width: '100%', height: 400}}/>
                            <div className="list">
                                <div>
                                    <List
                                        grid={{column: 5}}
                                        dataSource={list}
                                        renderItem={(item, index) => (
                                            <List.Item>
                                                <span className='list_box'>{index+1}</span><span
                                                className="skill_title">{item.name}</span>
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <Modal title={currentUser.name +(type === "MOCK"?"的模拟训练":"的正式考试")+ModalText} visible={visible} onCancel={this.handleCancel}
                               footer={null} destroyOnClose='true'>
                            <Table columns={columns} pagination={false}
                                   dataSource={orderList} rowKey={orderList => orderList.userTestPaperId}/>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}
